import httpClient from '@/api/http-client';

const endpoint = 'api/token-expiration';

const tokenExpirationService = {
  get: (params) => httpClient.get(endpoint, { params }),

  update: (tokenExpiration) => httpClient.post(`${endpoint}`, tokenExpiration),
};

export default tokenExpirationService;
